<div class="card">
    <div class="card-body">
        <div class="row" (click)="isCollapsed = !isCollapsed">
            <div
                class="col notification-detail-longtext-content"
                [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
                tabindex="0"
            >
                <div class="row mb-2">
                    <div class="col d-flex align-items-center">
                        <fa-icon
                            [icon]="isCollapsed ? faChevronRight : faChevronDown"
                            aria-hidden="true"
                            class="d-block d-lg-none me-3"
                        ></fa-icon>
                        <h3 class="user-select-auto m-0">{{ strings.notificationLongtextTitle }}</h3>
                    </div>
                </div>
                @for (text of notification.notificationLongtext; track text) {
                    <div class="user-select-auto mx-4 mx-lg-0" paceCoreLink [innerHTML]="text.TextLine"></div>
                }
            </div>
            <div
                class="col notification-detail-longtext-content d-none d-lg-block"
                [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
                tabindex="0"
            >
                <pace-preclarification
                    [preclarificationLongtextTitle]="strings.preclarificationLongtextTitle"
                    [preclarificationLongtext]="notification.preclarificationLongtext"
                ></pace-preclarification>
            </div>
        </div>
        @if (showExpander) {
            <div class="row d-none d-lg-block">
                <div class="col bg-white text-center" (click)="isCollapsed = !isCollapsed">
                    <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp"></fa-icon>
                    {{ isCollapsed ? strings.showMore : strings.showLess }}
                </div>
            </div>
        }
    </div>
</div>
@if (notification.preclarificationLongtext.length > 0) {
    <div class="card d-block d-lg-none mt-2">
        <div class="card-body">
            <pace-preclarification
                [preclarificationLongtextTitle]="strings.preclarificationLongtextTitle"
                [preclarificationLongtext]="notification.preclarificationLongtext"
            ></pace-preclarification>
        </div>
    </div>
}
